<template>
    <div v-if="cookie" class="c-basic-cookie-check">
        <slot />
    </div>
</template>
<script lang="ts" setup>
type CookieIdentifier = 'REQUIRED' | 'STATISTICS' | 'MARKETING' | 'PRODUCT_RATINGS';

const props = defineProps({
    identifyer: {
        type: String as PropType<CookieIdentifier>,
        required: true,
        validator: (value: string): value is CookieIdentifier =>
            ['REQUIRED', 'STATISTICS', 'MARKETING', 'PRODUCT_RATINGS'].includes(value as CookieIdentifier),
    },
    reloadRequired: {
        type: Boolean,
        default: false,
    },
});

const cookie = useState<boolean>(`cookie${props.identifyer}`);

watch(cookie, (hasConsent, hadConsent) => {
    if (import.meta.client && props.reloadRequired && !hadConsent && hasConsent) {
        window.location.reload();
    }
});
</script>